import { useQuery } from 'react-query';
import { getAssessmentQuestionConfig } from 'src/apis/assessmentQuestionConfig';
import { GetAssessmentQuestionConfigAPIResponse } from 'types';

export const useGetAssessmentQuestionConfigQuery = (
	args: { assessmentTemplateId: string; difficulty: number; tagRelationshipIds: string[] },
	onComplete?: (data: GetAssessmentQuestionConfigAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAssessmentQuestionConfig', args.assessmentTemplateId, args.difficulty, args.tagRelationshipIds],
		queryFn: async () =>
			(await getAssessmentQuestionConfig(
				args.assessmentTemplateId,
				args.difficulty,
				args.tagRelationshipIds,
			)) as GetAssessmentQuestionConfigAPIResponse,
		staleTime: 0,
		enabled: !!args.assessmentTemplateId && !!args.tagRelationshipIds.length && args.difficulty !== undefined,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
